// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"8759d2b0","194":"7a503888","518":"bc7ecba6","727":"64f6e40f","787":"072cd135"}[chunkId] + ".chunk.js";
};